<template>
  <div class="air-monitor-right-button-wrap">
    <template v-for="(btn, i) in btns">
      <div
        class="air-monitor-right-button_item"
        :ref="`air-monitor-right-button_item-${i}`"
        :class="{ 'is-active': isActive(btn.key) }"
        :key="btn.text"
        @click="open(btn)"
        @mouseover="handleMouseover(btn, i)"
        @mouseleave="hidePopover"
      >
        <img :src="btn.icon" :alt="btn.text" />
        <span>{{ $t(btn.text) }}</span>
      </div>
    </template>

    <MPopover
      :visible="visible"
      :position="popopPosition"
      :radiusNum="radiusNum"
      @mouseover.native="showPopover"
      @mouseleave.native="hidePopover"
    >
      <div class="company-list">
        <ul>
          <li
            v-for="item in children"
            :class="{ active: currentMenu === item.key }"
            :style="{
              '--radiusNum': radiusNum
            }"
            :key="item.key"
            @click="handleSwitchPage(item)"
          >
            {{ $t(item.text) }}
          </li>
        </ul>
      </div>
    </MPopover>
  </div>
</template>

<script>
import MPopover from '@/components/mPopover/index.vue';
import MForm from '@/components/form/index.vue';
import { useDialog } from '@/components/dialog/index';

import { officeTypeDict } from '@/utils/const/office';
import { isEmpty } from '@/utils/is';

const prefix = '/static/image/air-monitor/';

export default {
  components: { MPopover },
  props: {},
  data() {
    return {
      radiusNum: '20px',
      offices: [],
      visible: false,
      popopPosition: {},
      children: [],
      btns: [
        {
          text: '首页',
          key: 'AirMonitorHome',
          icon: `${prefix}home.png`
        },
        {
          text: '报警中心',
          key: 'AirMonitorAlarmCenter',
          icon: `${prefix}alarm-center.png`,
          children: [
            {
              text: '报警信息',
              key: 'AirMonitorAlarmInfo'
            },
            {
              text: '事件信息',
              key: 'AirMonitorEventInfo'
            }
          ]
        },
        {
          text: '应急中心',
          key: 'AirMonitorEmergencyCenter',
          icon: `${prefix}emergency-center.png`,
          children: [
            {
              text: '人员管理',
              key: 'AirMonitorPersonnelManage'
            },
            {
              text: '专家管理',
              key: 'AirMonitorExpertManage'
            },
            {
              text: '预案管理',
              key: 'AirMonitorPlanManage'
            },
            {
              text: '物资管理',
              key: 'AirMonitorMaterialsManage'
            }
          ]
        },
        {
          text: '信息中心',
          key: 'AirMonitorInformationCenter',
          icon: `${prefix}info-center.png`,
          children: [
            {
              text: '危险物信息',
              key: 'AirMonitorDangerousGoodsInfo'
            },
            {
              text: '日志信息',
              key: 'AirMonitorLogInfo'
            }
          ]
        },
        {
          text: '设备中心',
          key: 'AirMonitorDeviceCenter',
          icon: `${prefix}device-center.png`,
          children: [
            {
              text: '设备信息',
              key: 'AirMonitorDeviceInfo'
            },
            {
              text: '监测数据',
              key: 'AirMonitorMonitoringData'
            },
            {
              text: '运维信息',
              key: 'AirMonitorMaintenanceInfo'
            },
            {
              text: '故障信息',
              key: 'AirMonitorFaultInfo'
            }
          ]
        },
        {
          text: '统计中心',
          key: 'AirMonitorStatCenter',
          icon: `${prefix}stat-center.png`,
          children: [
            {
              text: '报警统计',
              key: 'AirMonitorAlarmStat'
            },
            {
              text: '事件统计',
              key: 'AirMonitorEventStat'
            }
          ]
        }
      ],
      formConfig: {
        config: {
          labelSuffix: ':',
          labelWidth: 'auto',
          span: 18,
          options: [
            {
              type: 'radioGroup',
              prop: 'saveduration',
              dataKey: 'savedurationOptions',
              label: '存储时长管理'
            }
          ],
          operation: {
            span: 6,
            buttons: [
              {
                text: '系统时长校准',
                size: 'mini',
                loading: false,
                type: 'primary',
                handler: async ({ setLoading }) => {
                  setLoading(true);
                  setLoading(false);
                }
              }
            ]
          }
        },
        model: {
          saveduration: 90
        },
        dataSource: {
          savedurationOptions: [
            { label: '检测数据90天', value: 90 },
            { label: '监测数据180天', value: 180 }
          ]
        },
        rules: {}
      }
    };
  },
  computed: {
    activeMenu() {
      return this.$route.meta.activeMenu;
    },
    currentMenu() {
      return this.$route.name;
    }
  },
  methods: {
    handleSwitchPage(item) {
      this.$router.push({
        name: item.key,
        params: {
          id: item.id
        }
      });
    },
    showSettings() {
      useDialog({
        title: this.$t('系统设置'),
        width: '600px',
        slots: {
          default: () => (
            <div style="height:100px;">
              <MForm props={this.formConfig} />
            </div>
          )
        }
      });
    },
    showPopover() {
      if (this.timer) clearTimeout(this.timer);

      this.visible = true;
    },
    hidePopover() {
      if (this.timer) clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        this.visible = false;
      }, 500);
    },
    handleMouseover(btn, i) {
      if (isEmpty(btn.children) || btn.children.length < 1) return;

      this.children = btn.children;

      const el = this.$refs[`air-monitor-right-button_item-${i}`][0];

      this.showPopover();

      this.popopPosition = {
        left: '0',
        top: `${el.offsetTop - 30}px`,
        transform: 'translateX(-100%)'
      };
    },
    isActive(key) {
      return this.activeMenu.indexOf(key) !== -1;
    },
    open(btn) {
      if (!isEmpty(btn.children)) return;

      if (this.activeMenu === btn.key) return;

      this.$router.push({
        name: btn.key
      });
    }
  },
  watch: {
    deviceTree: {
      handler(n) {
        const list = [officeTypeDict.getKeyByText('堆场'), officeTypeDict.getKeyByText('轧花厂')];

        this.offices.splice(0, Infinity);

        n?.forEach(e => {
          if (list.includes(+e.type)) {
            this.offices.push(e);
          }
        });
      },
      immediate: true
    },
    '$route.params': {
      handler() {
        const id = this.$route.params.id;

        if (isEmpty(id)) return;
      },
      immediate: true
    }
  }
};
</script>
X
<style lang="scss">
.air-monitor-right-button-wrap {
  border: 2px solid #047eba;
  border-radius: 110px;
  backdrop-filter: blur(4px);

  box-sizing: border-box;

  width: 110px;
  height: calc(100% - 50px);

  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  gap: 12px;

  padding: 25px 10px;

  position: absolute;
  right: 15px;
  bottom: 15px;
  z-index: 99;

  .air-monitor-right-button_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 100%;

    cursor: pointer;

    transition: all 0.3s;

    &.is-active {
      filter: brightness(1.5);
      scale: 1.1;

      span {
        font-weight: 600;
        color: #318eff;
      }
    }

    &:hover {
      filter: brightness(1.5);
    }

    img {
      width: 75%;
    }

    span {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 16px;
      color: var(--air-monitor-right-button-text-color, #fff);
      line-height: 23px;

      text-align: center;

      transition: all 0.3s;
    }
  }

  .air-monitor-setting {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 100%;

    cursor: pointer;

    transition: all 0.3s;

    i {
      font-size: 32px;
      color: #1aa8f9;
      margin-bottom: 8px;
    }

    span {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 16px;
      color: #fff;
      line-height: 23px;

      transition: all 0.3s;
    }

    &:hover {
      i {
        color: #1fc6c7;
      }
    }
  }

  .m-popover {
    --height: 200px;
  }

  .company-list {
    height: 100%;

    --title-height: 38px;

    &_title {
      height: var(--title-height);
      line-height: var(--title-height);
      text-align: center;
      font-size: 16px;
    }

    ul {
      height: 100%;
      overflow: auto;
      @include scrollar-style-thin;

      li {
        width: 100%;
        padding-left: 10%;
        line-height: 36px;
        box-sizing: border-box;
        position: relative;

        cursor: pointer;
        &:first-child {
          border-radius: var(--radiusNum) var(--radiusNum) 0 0;
        }

        &:hover,
        &.active {
          background: #185e9c;
        }

        &.active {
          &::before {
            content: '';

            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%);

            width: 3px;
            height: 3px;

            background: #fff;
            border-radius: 50%;
          }
        }
      }
    }
  }
}
</style>
